import { headerSearch } from "../../plugins/ComponentsUi/HeaderSearch/HeaderSearch";
import { detectCloseElement } from "./helper";
/*==================== Header ====================*/
/**
 * @param header
 */
const vw = $(window).width();
export const header = {
	scrollActive: function () {
		let height = $("header").height();
		if ($(window).scrollTop() > height) {
			$("header").addClass("active");
		} else {
			$("header").removeClass("active");
		}
	},
	mobile: function () {
		$(".header-hambuger").on("click", function () {
			$(this).toggleClass("active");
			$("body").toggleClass("isOpenMenu");
		});
	},
	initVariable: function () {
		const height = $("header").height();
		document.documentElement.style.setProperty("--header-height", `${height}px`);
	},
	headerOptions: function () {
		$(".header-dropdown-options").on("click", function () {
			$('body').toggleClass("isHeaderOptions");
		});
		detectCloseElement(".header-dropdown-options", "header-dropdown-options", function () {
			$('body').removeClass("isHeaderOptions");
		}, {
			onScroll: true
		});
	},
	headerSearchButton: function () {
		$(".header-search-button").on("click", function () {
			$(this).toggleClass("active");
			$(".header-search").toggleClass("active");
		});
	},
	init: function () {
		headerSearch();
		header.scrollActive();
		header.mobile();
		header.initVariable();
		header.headerSearchButton();
		header.headerOptions();
	},
};
document.addEventListener(
	"scroll",
	function (e) {
		header.scrollActive();
	},
	true
);
